import React from "react"

function Brain({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 9.6C17.5 8.6 16.5 8 15.3 8C13.8 8 12.5 9.1 12.2 10.5C10.8 10.7 9.7 12 9.7 13.6C9.7 13.7 9.7 13.8 9.7 13.9C8.6 14.6 8 15.8 8 17.1C8 17.9 8.2 18.7 8.7 19.3C8.2 20 8 20.7 8 21.5C8 22.9 8.7 24.1 9.9 24.8C10.4 26.7 12.1 28 14.1 28C15.8 28 17.3 27 18 25.5"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path
        d="M18 9.6C18.5 8.6 19.5 8 20.7 8C22.2 8 23.5 9.1 23.8 10.5C25.2 10.7 26.3 12 26.3 13.6C26.3 13.7 26.3 13.8 26.3 13.9C27.4 14.6 28 15.8 28 17.1C28 17.9 27.8 18.7 27.3 19.3C27.8 20 28 20.7 28 21.5C28 22.9 27.3 24.1 26.1 24.8C25.6 26.7 23.9 28 21.9 28C20.2 28 18.7 27 18 25.5"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path d="M18 9.6V25.5" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default Brain
